import { FILETYPE_ALARM, FILETYPE_PICTURE, FILETYPE_STREAMING, FILETYPE_VIDEO } from './app';

export const MEDIA_SAFE_GPT_ORIGIN = 'safe_gpt';
export const MEDIA_PLATFORM_ORIGIN = 'platform';
export const MEDIA_POSITION_ORIGIN = 'position';

export const MEDIA_ORIGIN_OPTIONS = [
  {
    id: MEDIA_SAFE_GPT_ORIGIN,
    label: 'Safe GPT',
  },
  {
    id: MEDIA_PLATFORM_ORIGIN,
    label: 'Plataforma',
  },
  {
    id: MEDIA_POSITION_ORIGIN,
    label: 'Posición',
  },
];

export const MEDIA_FILE_TYPES = {
  PICTURE: FILETYPE_PICTURE,
  VIDEO: FILETYPE_VIDEO,
  STREAMING: FILETYPE_STREAMING,
  ALARM: FILETYPE_ALARM,
} as const;

export const MEDIA_FILE_TYPE_OPTIONS = [
  {
    id: MEDIA_FILE_TYPES.PICTURE,
    label: 'Imagen',
  },
  {
    id: MEDIA_FILE_TYPES.VIDEO,
    label: 'Video',
  },
  {
    id: MEDIA_FILE_TYPES.STREAMING,
    label: 'Transmisión',
  },
  {
    id: MEDIA_FILE_TYPES.ALARM,
    label: 'Alarma',
  },
];
